export default __webpack_public_path__ + "static/media/products_424.310048bc.jpg";